<template>
  <a-descriptions bordered size="small" :column="2">
    <a-descriptions-item>
      <div slot="label" class="center">发起人</div>
      <div class="">
        {{ detail.extra.applicant }}
      </div>
    </a-descriptions-item>

    <a-descriptions-item :span="1">
      <div slot="label" class="center">发起部门</div>
      <div class="">
        {{ detail.extra.applicantDeptName }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">接收人</div>
      <div class="">
        {{ detail.extra.receiverName }}
      </div>
    </a-descriptions-item>

    <a-descriptions-item :span="1">
      <div slot="label" class="center">接收部门</div>
      <div class="">
        {{ detail.extra.receiverDeptName }}
      </div>
    </a-descriptions-item>
    <a-descriptions-item>
      <div slot="label" class="center">移交说明</div>
      <div class="">
        {{ detail.extra.description }}
      </div>
    </a-descriptions-item>
  </a-descriptions>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("approval", ["detail"]),
  },
};
</script>

